export const handleWaybillActionIcon = ({type, state, }) => {
    if( type === 104 && (state === 160 || state === 140 || state === 10)) {
        return true;
    } 

    return false;
}